import {BasicScenario} from '../../framework/parameters/BasicScenario';

export class CountryScenario extends BasicScenario {
manageCurrencies: boolean | null;
manageLanguages: boolean | null;
}

